import { GET_AVVISI_UTENTE, GET_AVVISI_UTENTE_SUCCESS, GET_PRESA_VISIONE, GET_PRESA_VISIONE_SUCCESS, GET_PROFILO, GET_PROFILO_SUCCESS, GET_ULTIMA_INFORMATIVA, GET_ULTIMA_INFORMATIVA_SUCCESS, PATCH_PROFILO, PATCH_PROFILO_SUCCESS, POST_PRESA_VISIONE, POST_PRESA_VISIONE_SUCCESS, POST_PROFILO, POST_PROFILO_SUCCESS, RESET_PROFILAZIONE_STATE } from "./actionsType";

export const getProfiloAction = () => ({
    type: GET_PROFILO,
})

export const getProfiloActionSuccess = (payload) => ({
    type: GET_PROFILO_SUCCESS,
    payload
})

export const postProfiloAction = (profilo) => ({
    type: POST_PROFILO,
    profilo
})

export const postProfiloActionSuccess = (payload) => ({
    type: POST_PROFILO_SUCCESS,
    payload
})

export const patchProfiloAction = (profilo) => ({
    type: PATCH_PROFILO,
    profilo
})

export const patchProfiloActionSuccess = (payload) => ({
    type: PATCH_PROFILO_SUCCESS,
    payload
})

export const getPresaVisioneAction = () => ({
    type: GET_PRESA_VISIONE,
})

export const getPresaVisioneActionSuccess = (payload) => ({
    type: GET_PRESA_VISIONE_SUCCESS,
    payload
})

export const getUltimaInformativaAction = () => ({
    type: GET_ULTIMA_INFORMATIVA,
})

export const getUltimaInformativaActionSuccess = (payload) => ({
    type: GET_ULTIMA_INFORMATIVA_SUCCESS,
    payload
})

export const postPresaVisioneAction = () => ({
    type: POST_PRESA_VISIONE,
})

export const postPresaVisioneActionSuccess = (payload) => ({
    type: POST_PRESA_VISIONE_SUCCESS,
    payload
})

export const getAvvisiUtenteAction = () => ({
    type: GET_AVVISI_UTENTE
})

export const getAvvisiUtenteActionSuccess = (payload) => ({
    type: GET_AVVISI_UTENTE_SUCCESS,
    payload
})

export const resetProfilazioneStateAction = () => ({
    type: RESET_PROFILAZIONE_STATE,

})